import { requestJson } from "../lib/api";

export function getWorldCupFixtures() {
  return requestJson("/api/world-cup/fixtures");
}

export function getChampionPredictionOverview() {
  return requestJson("/api/world-cup/champion-prediction");
}

export function saveChampionPrediction(payload) {
  return requestJson("/api/world-cup/champion-prediction", {
    method: "PUT",
    body: payload,
  });
}
